import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../components/form/LoadingButton";
import VariantCategoryForm, { VariantCategoryFormData } from "../../../components/admin/variantCategories/VariantCategoryForm";

export default function AdminAddVariantCategoryPage() {
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } } = useForm<VariantCategoryFormData>({
    defaultValues: {
      languages: [
        { languageCode: "en", title: "" },
        { languageCode: "ar", title: "" },
      ],
    },
  });

   const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (data: VariantCategoryFormData) => {
    updateResource(`variant-category`, 
        {languages:data.languages.map(la=>({languageCode:la.languageCode,name:la.title}))},
        "admin",{
            method: "POST",
            successMessage: t("createdSuccess"),
            invalidateQueries: ["variant-category-by-admin"],
            navigateAfter: () => navigate("/admin/variant-categories"),
          });
  };

  return (
    <div className="p-6 container">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_variant_category" />
        <VariantCategoryForm register={register} errors={errors} />
        {
        loading?
        <LoadingButton height={64}/> 
        :
        <SubmitButton height={64} label="create" />
        }
      </form>
    </div>
  );
}
